import { useNavigate } from 'react-router-dom'
import { useSnackbar } from 'notistack'
import { t } from '@lingui/macro'

import { useRequestHandler } from '@/hooks/useRequestHandler'
import { deletePatient as deletePatientAction, selectPatientDeleteRequestTracker } from '@/redux/reducers/patient.reducer'

export function useDeletePatient(patientId: string) {
  const navigate = useNavigate()
  const { enqueueSnackbar } = useSnackbar()

  const patientDeleteRequestHandler = useRequestHandler({
    onSuccess: () => {
      enqueueSnackbar(t`The patient has been deleted successfully.`, { variant: 'success' })
      navigate('/patients', { replace: true })
    },
    onError: () => enqueueSnackbar(t`An error has occured while deleting the patient. Please try again!`, { variant: 'error' }),
    requestTrackerSelector: selectPatientDeleteRequestTracker,
  })

  const deletePatient = () => {
    patientDeleteRequestHandler.dispatch(deletePatientAction(patientId))
  }

  return { deletePatient, isDeletingPatient: patientDeleteRequestHandler.requestTracker.loading }
}
